module.exports = __webpack_public_path__ + "img/login_pic.4209b433.png";